const color = {
  name: "color",
  path: "/color",
  title: "color",
  description: "Utilities for controlling the text color of an element.",
  value: {
  "color": {
    "text-color-inherit": "inherit",
    "text-color-current": "currentColor",
    "text-color-transparent": "transparent",
    "text-color-black": "var(--color-black)",
    "text-color-white": "var(--color-white)",
    "text-color-red-50": "var(--color-red-50)",
    "text-color-red-100": "var(--color-red-100)",
    "text-color-red-200": "var(--color-red-200)",
    "text-color-red-300": "var(--color-red-300)",
    "text-color-red-400": "var(--color-red-400)",
    "text-color-red-500": "var(--color-red-500)",
    "text-color-red-600": "var(--color-red-600)",
    "text-color-red-700": "var(--color-red-700)",
    "text-color-red-800": "var(--color-red-800)",
    "text-color-red-900": "var(--color-red-900)",
    "text-color-orange-50": "var(--color-orange-50)",
    "text-color-orange-100": "var(--color-orange-100)",
    "text-color-orange-200": "var(--color-orange-200)",
    "text-color-orange-300": "var(--color-orange-300)",
    "text-color-orange-400": "var(--color-orange-400)",
    "text-color-orange-500": "var(--color-orange-500)",
    "text-color-orange-600": "var(--color-orange-600)",
    "text-color-orange-700": "var(--color-orange-700)",
    "text-color-orange-800": "var(--color-orange-800)",
    "text-color-orange-900": "var(--color-orange-900)",
    "text-color-amber-50": "var(--color-amber-50)",
    "text-color-amber-100": "var(--color-amber-100)",
    "text-color-amber-200": "var(--color-amber-200)",
    "text-color-amber-300": "var(--color-amber-300)",
    "text-color-amber-400": "var(--color-amber-400)",
    "text-color-amber-500": "var(--color-amber-500)",
    "text-color-amber-600": "var(--color-amber-600)",
    "text-color-amber-700": "var(--color-amber-700)",
    "text-color-amber-800": "var(--color-amber-800)",
    "text-color-amber-900": "var(--color-amber-900)",
    "text-color-yellow-50": "var(--color-yellow-50)",
    "text-color-yellow-100": "var(--color-yellow-100)",
    "text-color-yellow-200": "var(--color-yellow-200)",
    "text-color-yellow-300": "var(--color-yellow-300)",
    "text-color-yellow-400": "var(--color-yellow-400)",
    "text-color-yellow-500": "var(--color-yellow-500)",
    "text-color-yellow-600": "var(--color-yellow-600)",
    "text-color-yellow-700": "var(--color-yellow-700)",
    "text-color-yellow-800": "var(--color-yellow-800)",
    "text-color-yellow-900": "var(--color-yellow-900)",
    "text-color-lime-50": "var(--color-lime-50)",
    "text-color-lime-100": "var(--color-lime-100)",
    "text-color-lime-200": "var(--color-lime-200)",
    "text-color-lime-300": "var(--color-lime-300)",
    "text-color-lime-400": "var(--color-lime-400)",
    "text-color-lime-500": "var(--color-lime-500)",
    "text-color-lime-600": "var(--color-lime-600)",
    "text-color-lime-700": "var(--color-lime-700)",
    "text-color-lime-800": "var(--color-lime-800)",
    "text-color-lime-900": "var(--color-lime-900)",
    "text-color-green-50": "var(--color-green-50)",
    "text-color-green-100": "var(--color-green-100)",
    "text-color-green-200": "var(--color-green-200)",
    "text-color-green-300": "var(--color-green-300)",
    "text-color-green-400": "var(--color-green-400)",
    "text-color-green-500": "var(--color-green-500)",
    "text-color-green-600": "var(--color-green-600)",
    "text-color-green-700": "var(--color-green-700)",
    "text-color-green-800": "var(--color-green-800)",
    "text-color-green-900": "var(--color-green-900)",
    "text-color-emerald-50": "var(--color-emerald-50)",
    "text-color-emerald-100": "var(--color-emerald-100)",
    "text-color-emerald-200": "var(--color-emerald-200)",
    "text-color-emerald-300": "var(--color-emerald-300)",
    "text-color-emerald-400": "var(--color-emerald-400)",
    "text-color-emerald-500": "var(--color-emerald-500)",
    "text-color-emerald-600": "var(--color-emerald-600)",
    "text-color-emerald-700": "var(--color-emerald-700)",
    "text-color-emerald-800": "var(--color-emerald-800)",
    "text-color-emerald-900": "var(--color-emerald-900)",
    "text-color-teal-50": "var(--color-teal-50)",
    "text-color-teal-100": "var(--color-teal-100)",
    "text-color-teal-200": "var(--color-teal-200)",
    "text-color-teal-300": "var(--color-teal-300)",
    "text-color-teal-400": "var(--color-teal-400)",
    "text-color-teal-500": "var(--color-teal-500)",
    "text-color-teal-600": "var(--color-teal-600)",
    "text-color-teal-700": "var(--color-teal-700)",
    "text-color-teal-800": "var(--color-teal-800)",
    "text-color-teal-900": "var(--color-teal-900)",
    "text-color-cyan-50": "var(--color-cyan-50)",
    "text-color-cyan-100": "var(--color-cyan-100)",
    "text-color-cyan-200": "var(--color-cyan-200)",
    "text-color-cyan-300": "var(--color-cyan-300)",
    "text-color-cyan-400": "var(--color-cyan-400)",
    "text-color-cyan-500": "var(--color-cyan-500)",
    "text-color-cyan-600": "var(--color-cyan-600)",
    "text-color-cyan-700": "var(--color-cyan-700)",
    "text-color-cyan-800": "var(--color-cyan-800)",
    "text-color-cyan-900": "var(--color-cyan-900)",
    "text-color-sky-50": "var(--color-sky-50)",
    "text-color-sky-100": "var(--color-sky-100)",
    "text-color-sky-200": "var(--color-sky-200)",
    "text-color-sky-300": "var(--color-sky-300)",
    "text-color-sky-400": "var(--color-sky-400)",
    "text-color-sky-500": "var(--color-sky-500)",
    "text-color-sky-600": "var(--color-sky-600)",
    "text-color-sky-700": "var(--color-sky-700)",
    "text-color-sky-800": "var(--color-sky-800)",
    "text-color-sky-900": "var(--color-sky-900)",
    "text-color-blue-50": "var(--color-blue-50)",
    "text-color-blue-100": "var(--color-blue-100)",
    "text-color-blue-200": "var(--color-blue-200)",
    "text-color-blue-300": "var(--color-blue-300)",
    "text-color-blue-400": "var(--color-blue-400)",
    "text-color-blue-500": "var(--color-blue-500)",
    "text-color-blue-600": "var(--color-blue-600)",
    "text-color-blue-700": "var(--color-blue-700)",
    "text-color-blue-800": "var(--color-blue-800)",
    "text-color-blue-900": "var(--color-blue-900)",
    "text-color-indigo-50": "var(--color-indigo-50)",
    "text-color-indigo-100": "var(--color-indigo-100)",
    "text-color-indigo-200": "var(--color-indigo-200)",
    "text-color-indigo-300": "var(--color-indigo-300)",
    "text-color-indigo-400": "var(--color-indigo-400)",
    "text-color-indigo-500": "var(--color-indigo-500)",
    "text-color-indigo-600": "var(--color-indigo-600)",
    "text-color-indigo-700": "var(--color-indigo-700)",
    "text-color-indigo-800": "var(--color-indigo-800)",
    "text-color-indigo-900": "var(--color-indigo-900)",
    "text-color-violet-50": "var(--color-violet-50)",
    "text-color-violet-100": "var(--color-violet-100)",
    "text-color-violet-200": "var(--color-violet-200)",
    "text-color-violet-300": "var(--color-violet-300)",
    "text-color-violet-400": "var(--color-violet-400)",
    "text-color-violet-500": "var(--color-violet-500)",
    "text-color-violet-600": "var(--color-violet-600)",
    "text-color-violet-700": "var(--color-violet-700)",
    "text-color-violet-800": "var(--color-violet-800)",
    "text-color-violet-900": "var(--color-violet-900)",
    "text-color-purple-50": "var(--color-purple-50)",
    "text-color-purple-100": "var(--color-purple-100)",
    "text-color-purple-200": "var(--color-purple-200)",
    "text-color-purple-300": "var(--color-purple-300)",
    "text-color-purple-400": "var(--color-purple-400)",
    "text-color-purple-500": "var(--color-purple-500)",
    "text-color-purple-600": "var(--color-purple-600)",
    "text-color-purple-700": "var(--color-purple-700)",
    "text-color-purple-800": "var(--color-purple-800)",
    "text-color-purple-900": "var(--color-purple-900)",
    "text-color-fuchsia-50": "var(--color-fuchsia-50)",
    "text-color-fuchsia-100": "var(--color-fuchsia-100)",
    "text-color-fuchsia-200": "var(--color-fuchsia-200)",
    "text-color-fuchsia-300": "var(--color-fuchsia-300)",
    "text-color-fuchsia-400": "var(--color-fuchsia-400)",
    "text-color-fuchsia-500": "var(--color-fuchsia-500)",
    "text-color-fuchsia-600": "var(--color-fuchsia-600)",
    "text-color-fuchsia-700": "var(--color-fuchsia-700)",
    "text-color-fuchsia-800": "var(--color-fuchsia-800)",
    "text-color-fuchsia-900": "var(--color-fuchsia-900)",
    "text-color-pink-50": "var(--color-pink-50)",
    "text-color-pink-100": "var(--color-pink-100)",
    "text-color-pink-200": "var(--color-pink-200)",
    "text-color-pink-300": "var(--color-pink-300)",
    "text-color-pink-400": "var(--color-pink-400)",
    "text-color-pink-500": "var(--color-pink-500)",
    "text-color-pink-600": "var(--color-pink-600)",
    "text-color-pink-700": "var(--color-pink-700)",
    "text-color-pink-800": "var(--color-pink-800)",
    "text-color-pink-900": "var(--color-pink-900)",
    "text-color-rose-50": "var(--color-rose-50)",
    "text-color-rose-100": "var(--color-rose-100)",
    "text-color-rose-200": "var(--color-rose-200)",
    "text-color-rose-300": "var(--color-rose-300)",
    "text-color-rose-400": "var(--color-rose-400)",
    "text-color-rose-500": "var(--color-rose-500)",
    "text-color-rose-600": "var(--color-rose-600)",
    "text-color-rose-700": "var(--color-rose-700)",
    "text-color-rose-800": "var(--color-rose-800)",
    "text-color-rose-900": "var(--color-rose-900)",
    "text-color-slate-50": "var(--color-slate-50)",
    "text-color-slate-100": "var(--color-slate-100)",
    "text-color-slate-200": "var(--color-slate-200)",
    "text-color-slate-300": "var(--color-slate-300)",
    "text-color-slate-400": "var(--color-slate-400)",
    "text-color-slate-500": "var(--color-slate-500)",
    "text-color-slate-600": "var(--color-slate-600)",
    "text-color-slate-700": "var(--color-slate-700)",
    "text-color-slate-800": "var(--color-slate-800)",
    "text-color-slate-900": "var(--color-slate-900)",
    "text-color-gray-50": "var(--color-gray-50)",
    "text-color-gray-100": "var(--color-gray-100)",
    "text-color-gray-200": "var(--color-gray-200)",
    "text-color-gray-300": "var(--color-gray-300)",
    "text-color-gray-400": "var(--color-gray-400)",
    "text-color-gray-500": "var(--color-gray-500)",
    "text-color-gray-600": "var(--color-gray-600)",
    "text-color-gray-700": "var(--color-gray-700)",
    "text-color-gray-800": "var(--color-gray-800)",
    "text-color-gray-900": "var(--color-gray-900)",
    "text-color-zinc-50": "var(--color-zinc-50)",
    "text-color-zinc-100": "var(--color-zinc-100)",
    "text-color-zinc-200": "var(--color-zinc-200)",
    "text-color-zinc-300": "var(--color-zinc-300)",
    "text-color-zinc-400": "var(--color-zinc-400)",
    "text-color-zinc-500": "var(--color-zinc-500)",
    "text-color-zinc-600": "var(--color-zinc-600)",
    "text-color-zinc-700": "var(--color-zinc-700)",
    "text-color-zinc-800": "var(--color-zinc-800)",
    "text-color-zinc-900": "var(--color-zinc-900)",
    "text-color-neutral-50": "var(--color-neutral-50)",
    "text-color-neutral-100": "var(--color-neutral-100)",
    "text-color-neutral-200": "var(--color-neutral-200)",
    "text-color-neutral-300": "var(--color-neutral-300)",
    "text-color-neutral-400": "var(--color-neutral-400)",
    "text-color-neutral-500": "var(--color-neutral-500)",
    "text-color-neutral-600": "var(--color-neutral-600)",
    "text-color-neutral-700": "var(--color-neutral-700)",
    "text-color-neutral-800": "var(--color-neutral-800)",
    "text-color-neutral-900": "var(--color-neutral-900)",
    "text-color-stone-50": "var(--color-stone-50)",
    "text-color-stone-100": "var(--color-stone-100)",
    "text-color-stone-200": "var(--color-stone-200)",
    "text-color-stone-300": "var(--color-stone-300)",
    "text-color-stone-400": "var(--color-stone-400)",
    "text-color-stone-500": "var(--color-stone-500)",
    "text-color-stone-600": "var(--color-stone-600)",
    "text-color-stone-700": "var(--color-stone-700)",
    "text-color-stone-800": "var(--color-stone-800)",
    "text-color-stone-900": "var(--color-stone-900)"
  }
},
  exampleData: [
    {
      example: {
        code: `
<p class="text-color-blue-600 dark:text-color-sky-400">The quick brown fox jumps over the lazy dog.</p>
<p class="text-color-inherit">The quick brown fox jumps over the lazy dog.</p>
<p class="text-color-blue-600/100 dark:text-color-sky-400/100">The quick brown fox jumps over the lazy dog.</p>
<p class="text-color-blue-600/75 dark:text-color-sky-400/75">The quick brown fox jumps over the lazy dog.</p>
<p class="text-color-blue-600/25 dark:text-color-sky-400/25">The quick brown fox jumps over the lazy dog.</p>
<p class="text-color-[#7ccf00] dark:text-color-[#ecfcca]">The quick brown fox jumps over the lazy dog.</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">text-color-*</code> utilities to control text color. Supports all palette colors, <code>inherit</code>, <code>currentColor</code>, and <code>transparent</code>.
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-blue-600 dark:text-color-sky-400</small>
          <p class="text-color-blue-600 dark:text-color-sky-400 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-inherit</small>
          <p class="text-color-inherit text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-current</small>
          <p class="text-color-current text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-blue-600/100 dark:text-color-sky-400/100</small>
          <p class="text-color-blue-600/100 dark:text-color-sky-400/100 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-blue-600/75 dark:text-color-sky-400/75</small>
          <p class="text-color-blue-600/75 dark:text-color-sky-400/75 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-blue-600/50 dark:text-color-sky-400/50</small>
          <p class="text-color-blue-600/50 dark:text-color-sky-400/50 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-blue-600/25 dark:text-color-sky-400/25</small>
          <p class="text-color-blue-600/25 dark:text-color-sky-400/25 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-[#7ccf00] dark:text-color-[#ecfcca]</small>
          <p class="text-color-[#7ccf00] dark:text-color-[#ecfcca] text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
    `
  }
]
}
export default color;

<div class="sr-only">
<div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-blue-600 dark:text-color-sky-400</small>
          <p class="text-color-blue-600 dark:text-color-sky-400 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-inherit</small>
          <p class="text-color-inherit text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-current</small>
          <p class="text-color-current text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-blue-600/100 dark:text-color-sky-400/100</small>
          <p class="text-color-blue-600/100 dark:text-color-sky-400/100 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-blue-600/75 dark:text-color-sky-400/75</small>
          <p class="text-color-blue-600/75 dark:text-color-sky-400/75 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-blue-600/50 dark:text-color-sky-400/50</small>
          <p class="text-color-blue-600/50 dark:text-color-sky-400/50 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-blue-600/25 dark:text-color-sky-400/25</small>
          <p class="text-color-blue-600/25 dark:text-color-sky-400/25 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-color-[#7ccf00] dark:text-color-[#ecfcca]</small>
          <p class="text-color-[#7ccf00] dark:text-color-[#ecfcca] text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
</div>